export default requester => {
    return {
        /**
         * Retrives preferences.
         */
        preferences () {
            return requester.get(`/me/preferences`);
        },

        /**
         * Save preferences.
         *
         * @param {object} payload
         **/
        savePreferences (payload = {}) {
            return requester.put('/me/preferences', payload);
        },

        /**
         * Get authenticated user's detailed info.
         */
        detailedMe(params = {}) {
            return requester.get('/me/detailed', { params });
        },

        /**
         * Get authenticated user's challenges.
         */
        myChallenges(params = {}) {
            return requester.get('/me/challenges', { params });
        },

        /**
         * Get a specific challenge for the authenticated user.
         */
        myChallenge(id) {
            return requester.get(`/me/challenges/${id}`);
        },

        /**
         * Get authenticated user's innovator data.
         */
        innovator(params = {}) {
            return requester.get('/me/innovator', { params });
        },

        /**
         * Disconnect a social account.
         */
        disconnectSocialAccount(provider) {
            return requester.delete(`/me/accounts/${provider}`);
        },
    };
}
